import type { SportProfile } from '@/types'

export const lacrosseWomens: SportProfile = {
  id: 'lacrosse-womens-outdoor',
  sport: 'lacrosse',
  gender: 'womens',
  environment: 'outdoor',
  label: "Women's Field Lacrosse",
  emoji: '🥍',
  playersOnField: 12,
  contactLevel: 'limited',
  hasShotClock: false,
  periods: { label: 'Half', count: 2, durationMinutes: 30 },
  positions: [
    { key: 'goalie', label: 'Goalie', shortLabel: 'G', maxOnField: 1 },
    { key: 'defense', label: 'Defender', shortLabel: 'D', maxOnField: 4 },
    { key: 'midfield', label: 'Midfielder', shortLabel: 'M', maxOnField: 3 },
    { key: 'attack', label: 'Attacker', shortLabel: 'A', maxOnField: 4 },
  ],
  stats: [
    { key: 'goal', label: 'Goal', shortLabel: 'G' },
    { key: 'assist', label: 'Assist', shortLabel: 'A' },
    { key: 'shot', label: 'Shot', shortLabel: 'SH' },
    { key: 'shot_on_goal', label: 'Shot on Goal', shortLabel: 'SOG' },
    { key: 'draw_control', label: 'Draw Control', shortLabel: 'DC', statType: 'faceoff-win' },
    { key: 'draw_stolen', label: 'Draw Stolen', shortLabel: 'DS', statType: 'faceoff-loss' },
    { key: 'ground_ball', label: 'Ground Ball', shortLabel: 'GB' },
    { key: 'turnover', label: 'Turnover', shortLabel: 'TOV' },
    { key: 'caused_turnover', label: 'Caused Turnover', shortLabel: 'CT' },
    { key: 'save', label: 'Save', shortLabel: 'SV' },
    { key: 'yellow_card', label: 'Yellow Card', shortLabel: 'YC', statType: 'card' },
    { key: 'red_card', label: 'Red Card', shortLabel: 'RC', statType: 'card' },
    { key: 'violation', label: 'Violation', shortLabel: 'VIO', statType: 'violation' },
    { key: 'opp_shot', label: 'Opp Shot', shortLabel: 'OPP', statType: 'opp-shot' },
  ],
}
